module.exports = __webpack_public_path__ + "static/media/48385414_2308769142531597_7190049336841994240_o.c738db3f.jpg";